import useStorage from "Hooks/useStorage";
import {useRedPill} from "Hooks/api/useRedPill";
import useAxios from "Setup/axios";

const useGetContent = () => {
    const {instance} = useAxios();
    const getPath = 'content.getContentPage';
    const {execute: executeGetPage} = useRedPill(getPath);
    const {setValue, storedValue: storedPromotionalTerms} = useStorage("promotionalTerms", null, "localStorage");

    const getPage = async (page) => {
        const res = await executeGetPage({url: page});

        try {
            if (res.code === 200) {
                return res.data;
            }
        } catch (e) {
            //sendExceptionToSentry(e);
            console.log(e);
            return false;
        }

        return false;
    };

    const getContent = async (page) => {
        const res = await instance.get(`/get-content/${page}`);
        const {data, code} = res.data;

        try {
            if (code === 200) {
                return data;
            }
        } catch (e) {
            //sendExceptionToSentry(e);
            console.log(e);
            return false;
        }

        return false;
    };

    const getPromotionalTerms = async () => {
        try {
            if (storedPromotionalTerms) {
                const now = new Date().getTime();
                const diff = Math.floor((now - storedPromotionalTerms.savedAt) / 1000);
                if (diff < (30 * 60)) {
                    return storedPromotionalTerms;
                }
            }
        } catch (e) {
            //sendExceptionToSentry(e);
            console.log(e);
        }

        const res = await getContent('promotional-terms');
        try {
            if (res) {
                res.savedAt = new Date().getTime();
                setValue(res);
            }
        } catch (e) {
            //sendExceptionToSentry(e);
            console.log(e);
        }

        return res;
    }

    return {getPage, getContent, getPromotionalTerms};
};

export default useGetContent;
